<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  status: {
    type: String,
    default: '',
  },
  // 'broadcast' | 'recipient'
  type: {
    type: String,
    default: 'broadcast',
  },
});

const { t } = useI18n();

const COLOR_MAP = {
  draft: 'bg-n-slate-3 text-n-slate-11',
  scheduled: 'bg-n-amber-3 text-n-amber-11',
  sending: 'bg-n-blue-3 text-n-blue-11',
  done: 'bg-n-teal-3 text-n-teal-11',
  failed: 'bg-n-ruby-3 text-n-ruby-11',
  cancelled: 'bg-n-slate-3 text-n-slate-11',
  pending: 'bg-n-slate-3 text-n-slate-11',
  sent: 'bg-n-teal-3 text-n-teal-11',
  skipped: 'bg-n-amber-3 text-n-amber-11',
  unsubscribed: 'bg-n-slate-3 text-n-slate-11',
};

const badgeClass = computed(
  () => COLOR_MAP[props.status] || 'bg-n-slate-3 text-n-slate-11'
);

const label = computed(() => {
  const group = props.type === 'recipient' ? 'RECIPIENT_STATUS' : 'STATUS';
  const key = `BROADCASTS.${group}.${props.status.toUpperCase()}`;
  return t(key) === key ? props.status : t(key);
});
</script>

<template>
  <span
    class="inline-flex items-center px-2 py-0.5 text-xs font-medium rounded-md"
    :class="badgeClass"
  >
    {{ label }}
  </span>
</template>
